import { useEffect, useState } from "react";
import Menu from "./Menu/Menu";
import StandingCard from "./StandingCard/StandingCard";
import useSize from "../../../../Utils/useSize/useSize";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";
import Loading from "../../../../Utils/Loading/Loading";
import useSound from "use-sound";
import Error from "../../../../Sound/Error.wav";
import NotFound from "../../../../Utils/NotFound/NotFound";
import { useDispatch } from "react-redux";

import Filter from "./Filter/Filter";

const backend = await new Backend().init();

export default function SuperWise() {
  const [play] = useSound(Error);
  const windowSize = useSize();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [position, setPosition] = useState([]);

  useEffect(() => {
    loadStanding();
  }, []);

  const loadStanding = () => {
    setLoading(true);
    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      super: "1",
    };

    backend.standing_admin(data).then((r) => {
      setLoading(false);
      if (r.error == "False") {
        setPosition(r.standing);
        dispatch({ type: "CLEAR_PF" });
      } else {
        if (r.logout == 1) {
          window.LogOut();
        } else {
          ErrorSound();
          toast.error(r.message);
        }
      }
    });
  };

  const ErrorSound = () => {
    play();
  };


  return (
    <div>
      <Filter records={position.length} />
      <Menu />
      <div
        key={loading}
        style={{
          width: windowSize[0],
          height: windowSize[1] - 160,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {loading ? (
          <div className="loadingContainer">
            <Loading height={windowSize[1] - 160} />
          </div>
        ) : position.length > 0 ? (
          <div
            style={{
              width: windowSize[0],
              height: windowSize[1] - 160,
              overflowY: "scroll",
            }}
          >
            {position.map((item, index) => {
              return (
                <StandingCard key={item.id} item={item} index={index + 1} />
              );
            })}
          </div>
        ) : (
          <NotFound height={windowSize[1] - 160} title={"Nothing here"} subtext={"No User Found."} />
        )}
      </div>
    </div>
  );
}
